<div *ngIf="alerts.length">
  <div *ngFor="let alert of alerts" [ngClass]="apAlertClassByType.get(alert.type)" [class.fade]="alert.fade" id="ap-alert-{{alert.id}}-{{alert.htmlBaseId}}">
    <span [innerHTML]="alert.message"></span>
    <a class="close"
       id="ap-alert-{{alert.id}}-{{alert.htmlBaseId}}-close"
       (click)="removeAlert(alert)">&times;</a>
  </div>
</div>
<div class="alert-errors-container" *ngIf="alertErrors.length">
  <div *ngFor="let alert of alertErrors" [ngClass]="apAlertClassByType.get(alert.type)" [class.fade]="alert.fade" id="ap-alert-errors-{{alert.id}}-{{alert.htmlBaseId}}">
    <span [innerHTML]="alert.message"></span>
    <a class="close"
       id="ap-alert-error-{{alert.id}}-{{alert.htmlBaseId}}-close"
       (click)="removeAlert(alert)">&times;</a>
  </div>
</div>
